import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GameRules } from '../shared/consts/page-home-data';
import { GameRulesDialogComponent } from '../game-rules-dialog/game-rules-dialog.component';

@Component({
  selector: 'pbg-page-home',
  templateUrl: './page-home.component.html',
  styleUrls: ['./page-home.component.scss']
})
export class PageHomeComponent implements OnInit {
  game = 'trivia';
  gameData: {};

  constructor(public dialog: MatDialog) {}

  ngOnInit() {
    this.gameData = GameRules;
  }

  openDialog(game: string): void {
    this.game = game;
    const dialogRef = this.dialog.open(GameRulesDialogComponent, {
      width: '800px',
      data: { game: this.game, rules: this.gameData[this.game] }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
}
